import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Nunca pensé que en 5 minutos podía sentir tanta diferencia. Ahora es mi rutina de todos los días.',
    author: 'Sofía',
    age: '28 años'
  }, {
    quote: 'Probé muchos diarios antes, pero siempre los dejaba. Esto es distinto. Simple, corto y realmente me ordena la cabeza.',
    author: 'Martín',
    age: '34 años'
  }, {
    quote: 'Lo empecé sin muchas expectativas y al tercer día ya sentía un cambio. Me ayuda a arrancar el día con más claridad.',
    author: 'Camila',
    age: '31 años'
  }, {
    quote: 'Es exactamente lo que necesitaba: algo corto, sin vueltas, que realmente funcione. Lo recomiendo a todos.',
    author: 'Lucas',
    age: '27 años'
  }, {
    quote: 'Siempre me costó poner en palabras lo que siento. Las 3 preguntas me guían y en minutos ya me siento más liviana.',
    author: 'Valentina',
    age: '36 años'
  }, {
    quote: 'Los audios son un golazo. Me relajan antes de escribir y hacen que todo el proceso sea mucho más fácil.',
    author: 'Nicolás',
    age: '30 años'
  }];
  return <section className="py-24 px-4 bg-[#FDF8F3]" data-id="element-140">
      <div className="container max-w-5xl mx-auto" data-id="element-141">
        <FadeIn data-id="element-142">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#3D3229] mb-16" data-id="element-143">
            Lo que dicen quienes ya lo probaron:
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-144">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.15} className="h-full" data-id="element-145">
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-[#3D3229]/5 h-full relative" data-id="element-146">
                <Quote className="absolute top-6 left-6 w-8 h-8 text-[#C4703F]/20" data-id="element-147" />
                <blockquote className="relative z-10 mt-4" data-id="element-148">
                  <p className="text-lg text-[#3D3229]/80 italic mb-6 leading-relaxed" data-id="element-149">
                    "{testimonial.quote}"
                  </p>
                  <footer className="flex items-center gap-3" data-id="element-150">
                    <div className="w-10 h-10 rounded-full bg-[#8B9E7E]/20 flex items-center justify-center text-[#8B9E7E] font-bold font-serif" data-id="element-151">
                      {testimonial.author[0]}
                    </div>
                    <div data-id="element-152">
                      <cite className="not-italic font-bold text-[#3D3229] block" data-id="element-153">
                        {testimonial.author}
                      </cite>
                      <span className="text-sm text-[#3D3229]/60" data-id="element-154">
                        {testimonial.age}
                      </span>
                    </div>
                  </footer>
                </blockquote>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}